  <template>
    <section class="top-slider-home" id="top-slider">

      <template>
        <b-skeleton-img v-if="!sliderData"></b-skeleton-img>
        <div class="to-slider-home2 main-container" v-else-if="sliders.length">
          <div class="w-100 h-100">
            <div id="top-slider-new" class="top-slider-new position-relative w-100">
              <div class="swiper-container h-100 w-100">
                <div class="swiper-wrapper">
                  <div v-for="slider in sliders" :key="slider.id" class="swiper-slide ">
                    <div v-if="slider.description" class="
                        top-slider-content
                        d-flex
                        justify-content-between
                        container
                        mx-auto
                      ">
                      <div class="text-right my-auto ml-3">
                        <span class="
                            top-header-discount
                            bg-color-themeRed
                            fontsize-mini
                            text-white
                            px-2
                          " v-if="
                            slider.custom_fields && slider.custom_fields.discount
                          ">{{ slider.custom_fields.discount }}</span>
                        <h5 class="font-weight-bold fontsize-heavy mb-3 mt-sm-3 mt-2 text-color-444">
                          {{ slider.title }}
                        </h5>
                        <p class="
                            fontsize-medium
                            text-justify text-color-444
                            line-height2
                            d-lg-block d-none
                          ">
                          {{ slider.description }}
                        </p>
                        <div>
                          <router-link v-if="slider.linkable_type != null" :to="findUrl(slider.linkable_type, slider.linkable_id)
                            ">
                            <button type="button" class="
                                top-slider-cart
                                text-white
                                bg-color-theme
                                fontsize-mini
                                weight-bold
                                py-md-2 py-1
                                px-md-3 px-2
                                ml-md-3 ml-2
                              ">
                              خرید این محصول
                            </button>
                          </router-link>
                          <a v-else :href="slider.link">
                            <button type="button" class="
                                top-slider-cart
                                text-white
                                bg-color-theme
                                fontsize-mini
                                weight-bold
                                py-md-2 py-1
                                px-md-3 px-2
                                ml-md-3 ml-2
                              ">
                              خرید این محصول
                            </button>
                          </a>

                          <router-link v-if="slider.linkable_type != null" :to="findUrl(slider.linkable_type, slider.linkable_id)
                            ">
                            <button type="button" class="
                                top-slider-more
                                d-md-inline-block d-none
                                text-color-666
                                fontsize-mini
                                py-md-2 py-1
                                px-md-3 px-2
                                bg-none
                              ">
                              اطلاعات بیشتر ...
                            </button>
                          </router-link>

                          <a v-else :href="slider.link">
                            <button type="button" class="
                                top-slider-more
                                d-md-inline-block d-none
                                text-color-666
                                fontsize-mini
                                py-md-2 py-1
                                px-md-3 px-2
                                bg-none
                              ">
                              اطلاعات بیشتر ...
                            </button>
                          </a>
                        </div>
                      </div>
                    </div>
                    <figure class="w-100 h-100 m-0  left-image">
                      <DynamicLinker class="top-slider-img" :item="slider">
                        <img width="1300" height="420" loading="eager" decoding="async"
                          class="w-100 h-auto image-slider-home" :src="slider.image.url" :alt="slider.title"
                          :title="slider.title" />
                      </DynamicLinker>
                    </figure>
                  </div>
                  <div v-for="slider in sliders" :key="slider.id" class="swiper-slide ">
                    <div v-if="slider.description" class="
                        top-slider-content
                        d-flex
                        justify-content-between
                        container
                        mx-auto
                      ">
                      <div class="text-right my-auto ml-3">
                        <span class="
                            top-header-discount
                            bg-color-themeRed
                            fontsize-mini
                            text-white
                            px-2
                          " v-if="
                            slider.custom_fields && slider.custom_fields.discount
                          ">{{ slider.custom_fields.discount }}</span>
                        <h5 class="font-weight-bold fontsize-heavy mb-3 mt-sm-3 mt-2 text-color-444">
                          {{ slider.title }}
                        </h5>
                        <p class="
                            fontsize-medium
                            text-justify text-color-444
                            line-height2
                            d-lg-block d-none
                          ">
                          {{ slider.description }}
                        </p>
                        <div>
                          <router-link v-if="slider.linkable_type != null" :to="findUrl(slider.linkable_type, slider.linkable_id)
                            ">
                            <button type="button" class="
                                top-slider-cart
                                text-white
                                bg-color-theme
                                fontsize-mini
                                weight-bold
                                py-md-2 py-1
                                px-md-3 px-2
                                ml-md-3 ml-2
                              ">
                              خرید این محصول
                            </button>
                          </router-link>
                          <a v-else :href="slider.link">
                            <button type="button" class="
                                top-slider-cart
                                text-white
                                bg-color-theme
                                fontsize-mini
                                weight-bold
                                py-md-2 py-1
                                px-md-3 px-2
                                ml-md-3 ml-2
                              ">
                              خرید این محصول
                            </button>
                          </a>

                          <router-link v-if="slider.linkable_type != null" :to="findUrl(slider.linkable_type, slider.linkable_id)
                            ">
                            <button type="button" class="
                                top-slider-more
                                d-md-inline-block d-none
                                text-color-666
                                fontsize-mini
                                py-md-2 py-1
                                px-md-3 px-2
                                bg-none
                              ">
                              اطلاعات بیشتر ...
                            </button>
                          </router-link>

                          <a v-else :href="slider.link">
                            <button type="button" class="
                                top-slider-more
                                d-md-inline-block d-none
                                text-color-666
                                fontsize-mini
                                py-md-2 py-1
                                px-md-3 px-2
                                bg-none
                              ">
                              اطلاعات بیشتر ...
                            </button>
                          </a>
                        </div>
                      </div>
                    </div>
                    <figure class="w-100 h-100 m-0  left-image">
                      <DynamicLinker class="top-slider-img" :item="slider">
                        <img loading="eager" width="1300" height="420" decoding="async"
                          class="w-100 h-auto  image-slider-home" :src="slider.image.url" :alt="slider.title"
                          :title="slider.title" />
                      </DynamicLinker>
                    </figure>
                  </div>
                </div>
                <!-- Add Pagination -->
                <!-- <div class=" swiper-pagination"></div> -->
                <!-- Add Arrows -->
              </div>
            </div>
          </div>
        </div>
      </template>
    </section>
  </template>

<script>
import Swiper from "swiper/swiper-bundle.min.js";

import findUrl from "@/libraries/links/LinkResolver";

import DynamicLinker from "./DynamicLinker";
import { BSkeletonImg } from "bootstrap-vue";
// import "swiper/css/effect-fade";
import "swiper/components/effect-fade/effect-fade.min.css";
export default {
  name: "slider",
  components: {
    DynamicLinker,
    BSkeletonImg,
  },
  watch: {
    sliderData() {
      this.initHeaderSwiper(true);
    },
  },
  inject: ["mediaQueries"],
  methods: {
    getSlidersFromServer() {
      this.$store.dispatch("front/getSlidersFromServer");
    },
    findUrl,
    getSliderCustomFields(slider) {
      return JSON.parse(slider.custom_fields);
    },

    onResize() {
      let topSliderH = document.querySelector(".top-slider-home1");
      let topSliderImg = document.querySelector(".image-slider-home1");

      let bodyWidth = document.body.offsetWidth;
      if (topSliderH) {
        if (bodyWidth < 1000) {
          topSliderH.style.height = bodyWidth / 2.6 + "px";
          // topSliderImg.style.height = bodyWidth / 2.6 + "px";
        }
        if (bodyWidth < 600) {
          topSliderH.style.height = bodyWidth / 2.4 + "px";
          //  topSliderImg.style.height = bodyWidth / 2 + "px";
        } else {
          topSliderH.style.height = bodyWidth / 3.5 + "px";
          // topSliderImg.style.height = bodyWidth / 3.5 + "px";
        }
      }
    },
    initHeaderSwiper(kill = false) {
      this.initSwiper("header-swiper", kill, () => {
        new Swiper(".top-slider-home .swiper-container", {
          spaceBetween: 0,
          //   centeredSlides: true,
          effect: "fade",
          fadeEffect: {
            crossFade: true,
          },
          speed: 3500,
          loop: false,
          autoplay: {
            delay: 3500,
            disableOnInteraction: false,
          },
          // pagination: {
          //   el: ".top-slider-home .swiper-pagination",
          //   clickable: true,
          // },
          navigation: {
            nextEl: ".top-slider-home .swiper-button-next",
            prevEl: ".top-slider-home .swiper-button-prev",
          },
        });
      });
      this.$nextTick(() => {
        this.onResize();
      });
    },
  },
  mounted() {
    if (this.sliderData) {
      this.initHeaderSwiper();
    } else {
      this.getSlidersFromServer();
    }
    window.removeEventListener("resize", this.onResize);
    window.addEventListener("resize", this.onResize);
    const topSliderH = document.querySelector(".top-slider-home1");
    const bodyWidth = document.body.offsetWidth;
    if (topSliderH) {
      if (bodyWidth < 767) {
        // topSliderH.style.height = bodyWidth / 1.6 + "px";
      } else {
        // topSliderH.style.height = bodyWidth / 2.2 + "px";
      }
    }

    window.removeEventListener("resize", this.onResize);
    window.addEventListener("resize", this.onResize);
  },
  computed: {
    // دریافت دیتا از سمت ویوایکس
    sliderData() {
      if (this.$store.getters["front/getHomeData"] != null) {
        return this.$store.getters["front/getHomeData"].sliders;
      } else {
        return null;
      }
    },
    sliders() {
      let sliders;

      if (this.sliderData && this.sliderData.length) {
        if (this.mediaQueries.medium) {
          sliders = this.sliderData.filter((s) => s.group.includes("mobile"));
        } else {
          sliders = this.sliderData.filter((s) => !s.group.includes("mobile"));
        }
        sliders.forEach((slider) => {
          try {
            slider.custom_fields = this.getSliderCustomFields(slider);
          } catch (e) { }
        });
        return sliders;
      }
    },
  },
};
</script>

<style scoped>
.top-slider-img {
  position: unset;
}

.rigth-slider figure {
  height: calc(50% - 8px);
}

.rigth-slider img {
  height: 100%;
  border-radius: 16px;
}

.to-slider-home2 {
  margin-top: 2rem;
  height: 100%;
}

.left-image {
  overflow: hidden;
  border-radius: 16px;
}

.top-slider-new {
  height: 100%;
}

@media screen and (max-width: 639px) {
  .to-slider-home2 {
    margin-top: 1rem;
  }

  .main-container {
    width: 100%;
  }

  .rigth-slider img {
    border-radius: 0px;
  }

  .left-image {
    border-radius: 0px;
  }
}
</style>
<style></style>
